import * as React from 'react'
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl'

import Button from '../../../../components/button'
import SubTitle from '../../../../components/sub-title'
import { Card, CardHeader, CardBody, CardTitle } from '../../../../components/card'

import card_1 from './card_1.png'
import card_2 from './card_2.png'
import card_3 from './card_3.png'

import styles from './intro.module.scss'
import { pushGAEvent } from '../../../../lib/utils'
import VideoPopup from '../../../../components/videopopup'

interface IStartProps {
  variant?: 'video1' | 'video2' | 'video3' | 'promoNewCompanies'
}

const video1 = 'https://www.youtube-nocookie.com/embed/EhBTtS2VNTY?rel=0&autoplay=1'
const video2 = 'https://www.youtube-nocookie.com/embed/x6L5YouLgCE?rel=0&autoplay=1'
const video3 = 'https://www.youtube-nocookie.com/embed/O5SSTH_u6gY?rel=0&autoplay=1'

export default function Intro({ variant = 'video1' }: IStartProps) {
  const [showVideo, toggleVideo] = React.useState<string>()

  return (
    <div className={styles.root}>
      <div className={styles.outer}>
        <div className={styles.inner}>
          <div className={styles.heading}>
            <FormattedHTMLMessage
              defaultMessage="Allt i ett, helt gratis"
              id="landingPage.intro.heading"
              tagName="h2"
            />
          </div>

          <div className={styles.description}>
            <FormattedHTMLMessage
              defaultMessage="Gör som andra smarta företagare och hantera <br/>hela företagets ekonomi helt gratis i Dooer.<br/>Yep, precis så enkelt som det borde vara."
              id="landingPage.intro.lede"
              tagName="p"
            />
          </div>

          <div className={styles.cardWrapper}>
            <Card>
              <CardHeader variant="free">
                <CardTitle className={styles.cardTitle}>
                  <SubTitle>
                    <FormattedMessage defaultMessage="Bokföring" id="landingPage.intro.acc-title" />
                  </SubTitle>
                </CardTitle>
              </CardHeader>
              <CardBody className={styles.cardBody}>
                <img
                  alt="card 1"
                  aria-hidden="true"
                  onClick={() => {
                    toggleVideo(video1)
                    pushGAEvent('click-start-promo-video-play')
                  }}
                  src={card_1}
                  style={{ cursor: 'pointer' }}
                />

                <div style={{ position: 'relative' }}>
                  {['video1', 'video2', 'video3'].includes(variant) && showVideo && (
                    <VideoPopup
                      close={() => toggleVideo('')}
                      video={{
                        src: showVideo,
                        title: 'Dooer info video',
                      }}
                      wide={variant === 'video1'}
                    />
                  )}
                </div>

                <FormattedMessage
                  defaultMessage="Hantera bokföringen tryggt med smarta integrationer till din bank och Skatteverket."
                  id="landingPage.product.product-1-desc"
                  tagName="p"
                />
                <div className={styles.line} />
                <Button block href="/bokforing" variant="pureWhite">
                  <FormattedMessage defaultMessage="Läs mer" id="landingPage.intro.salary-cta" />
                </Button>
              </CardBody>
            </Card>
            <Card>
              <CardHeader variant="free">
                <CardTitle className={styles.cardTitle}>
                  <SubTitle>
                    <FormattedMessage defaultMessage="Fakturering" id="landingPage.intro.billing-title" />
                  </SubTitle>
                </CardTitle>
              </CardHeader>
              <CardBody className={styles.cardBody}>
                <img
                  alt="card 1"
                  aria-hidden="true"
                  onClick={() => {
                    toggleVideo(video2)
                    pushGAEvent('click-start-promo-video-play')
                  }}
                  src={card_2}
                  style={{ cursor: 'pointer' }}
                />
                <FormattedMessage
                  defaultMessage="Fakturera med några klick och få betalt snabbt med till exempel kort, swish eller Apple pay."
                  id="landingPage.product.product-2-desc"
                  tagName="p"
                />
                <div className={styles.line} />
                <Button block href="/fakturering" variant="pureWhite">
                  <FormattedMessage defaultMessage="Läs mer" id="landingPage.intro.billing-cta" />
                </Button>
              </CardBody>
            </Card>
            <Card>
              <CardHeader variant="free">
                <CardTitle className={styles.cardTitle}>
                  <SubTitle>
                    <FormattedMessage defaultMessage="Lön" id="landingPage.intro.salary-title" />
                  </SubTitle>
                </CardTitle>
              </CardHeader>
              <CardBody className={styles.cardBody}>
                <img
                  alt="card 1"
                  aria-hidden="true"
                  onClick={() => {
                    toggleVideo(video3)
                    pushGAEvent('click-start-promo-video-play')
                  }}
                  src={card_3}
                  style={{ cursor: 'pointer' }}
                />
                <FormattedMessage
                  defaultMessage="Gör lönekörningar, hantera utlägg och skicka in AGI till Skatteverket med ett klick."
                  id="landingPage.intro.salary-desc"
                  tagName="p"
                />
                <div className={styles.line} />
                <Button block href="/lon" variant="pureWhite">
                  <FormattedMessage defaultMessage="Läs mer" id="landingPage.intro.salary-cta" />
                </Button>
              </CardBody>
            </Card>
          </div>
        </div>
      </div>
    </div>
  )
}
// export default Intro
